const subtitle = (price, freeTrial, isBreachUser, deferredProductPrice, basicToBreach, isAnnual = false) => {
  if ((isBreachUser && !deferredProductPrice) || basicToBreach) {
    return 'Your subscription is complimentary';
  }
  if (!isBreachUser && price) {
    return freeTrial ? `Free for 30 days, then it’s ${price} every month from then on.` : `${price} every month`;
  }
  if (isBreachUser && deferredProductPrice) {
    const period = isAnnual ? 'year' : 'month';
    return freeTrial
      ? `Free for 30 days, then it’s £${deferredProductPrice} every ${period} from then on.`
      : `£${deferredProductPrice} every ${period}`;
  }
  if (freeTrial) {
    return 'Free for 30 days';
  }
  return '';
};

export default subtitle;
